export default {"src":"/_next/static/media/DareDropLogoGray.30fe85e4.svg","height":55,"width":200};